/* BAI Europe — comportements.
   Reecriture du script de la maquette en JavaScript simple. Aucun cadre,
   aucune dependance : le theme doit rester lisible par la personne qui
   reprendra le magasin, et un theme Shopify recharge une section seule
   dans l'editeur, ce qu'un composant a etat global supporte mal.

   Regle tenue partout : si le script ne part pas, la page reste lisible
   et achetable. Les etats fermes sont portes par l'attribut hidden, donc
   le contenu existe meme sans JavaScript. */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── WhatsApp ────────────────────────────────────────────────────────
     Le numero est un reglage de theme, ecrit une seule fois. On construit
     le lien ici plutot que dans dix gabarits : un numero recopie dix fois
     est un numero faux a neuf endroits le jour ou il change. */
  var wa = (window.BAI && window.BAI.whatsapp) || document.documentElement.dataset.wa || '';
  if (wa) {
    $$('[data-bai-whatsapp]').forEach(function (a) {
      a.href = 'https://wa.me/' + wa.replace(/[^0-9]/g, '');
      a.target = '_blank';
      a.rel = 'noopener';
    });
  }

  /* ── Couches : une seule a la fois ───────────────────────────────── */
  var voile = $('.ecran-voile');
  var barre = $('.barre-bas');
  var ouverte = null;
  var rendeur = null;

  // Le tiroir ouvert garde la barre cachee, meme quand une autre couche se ferme.
  function masqueBarre(oui) {
    if (!barre) return;
    var tiroir = rangee && rangee.dataset.menu === 'true';
    barre.dataset.masquee = (oui || tiroir) ? 'true' : 'false';
  }

  function ferme() {
    if (!ouverte) return;
    ouverte.hidden = true;
    if (voile) voile.hidden = true;
    masqueBarre(false);
    document.body.style.overflow = '';
    var r = rendeur; ouverte = null; rendeur = null;
    if (r && document.contains(r)) r.focus();
  }

  function ouvre(el, depuis) {
    ferme();
    if (!el) return;
    ouverte = el; rendeur = depuis || null;
    el.hidden = false;
    if (voile) voile.hidden = false;
    masqueBarre(true);
    document.body.style.overflow = 'hidden';
    var premier = el.querySelector('input, button, a[href], [tabindex]:not([tabindex="-1"])');
    (premier || el).focus();
  }

  $$('[data-bai-close]').forEach(function (b) { b.addEventListener('click', ferme); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { ferme(); fermeVolets(); fermeTiroir(true); } });

  var btnSearch = $('[data-bai-search]');
  if (btnSearch) btnSearch.addEventListener('click', function () { ouvre($('#dlg-search'), btnSearch); });

  /* ── Panier ──────────────────────────────────────────────────────────
     On ne recopie pas le panier au rendu de la page : la feuille montrerait
     l'etat au moment du rendu, c'est-a-dire faux des le premier ajout. On
     le relit sur /cart.js a chaque ouverture. */
  var btnCart = $('[data-bai-cart]');
  var cptCart = $('[data-bai-cart-count]');

  function euros(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function dessinePanier(p) {
    var corps = $('[data-bai-cart-body]');
    if (!corps) return;
    if (cptCart) {
      var avant = parseInt(cptCart.textContent, 10) || 0;
      cptCart.textContent = p.item_count;
      if (p.item_count > avant && btnCart) {
        btnCart.classList.remove('panier-plus'); void btnCart.offsetWidth; btnCart.classList.add('panier-plus');
      }
    }
    if (!p.items || !p.items.length) {
      corps.innerHTML = '<p class="t-body">' + (corps.dataset.vide || 'Your cart is empty.') + '</p>';
      return;
    }
    var html = '<ul class="panier-liste">';
    p.items.forEach(function (it) {
      // La variante est la commande : « MIRROR » seul ne dit pas qu'on a
      // choisi Designing et le pack Premium.
      var vt = it.variant_title && it.variant_title !== 'Default Title'
        ? '<span class="panier-var t-sm">' + String(it.variant_title).replace(/[<>&]/g, '') + '</span>' : '';
      html += '<li class="panier-ligne"><span class="t-body">' + it.quantity + ' &times; '
           +  it.product_title.replace(/[<>&]/g, '') + vt + '</span>'
           +  '<span class="t-body t-semi t-num">' + euros(it.final_line_price) + '</span></li>';
    });
    html += '</ul><p class="panier-total t-h5"><span>Total</span><span class="t-num">'
         +  euros(p.total_price) + '</span></p>';
    corps.innerHTML = html;
  }

  /* Le tiroir s'ouvrait sur le vide pendant l'aller-retour reseau. Entre
     « ca charge » et « c'est casse », le visiteur tranche toujours pour le
     second, et il reclique. Trois lignes grises a la forme du contenu qui
     arrive : la promesse est tenue avant meme que la reponse revienne.

     La forme compte. Un rond qui tourne dit « attends » ; un squelette dit
     « voila ce qui vient », et quand les vraies lignes se posent, rien ne
     saute. */
  function squelettePanier() {
    var corps = $('[data-bai-cart-body]');
    if (!corps) return;
    var h = '<ul class="panier-liste" aria-hidden="true">';
    for (var i = 0; i < 3; i++) {
      h += '<li class="panier-ligne"><span class="t-body bai-squelette" style="width:' +
           (62 - i * 9) + '%"></span>' +
           '<span class="t-body bai-squelette" style="width:18%"></span></li>';
    }
    h += '</ul>';
    corps.innerHTML = h;
    corps.setAttribute('aria-busy', 'true');
  }

  function litPanier() {
    squelettePanier();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(dessinePanier)
      .catch(function () {
        // Hors ligne, le squelette mentirait indefiniment : on le dit.
        var corps = $('[data-bai-cart-body]');
        if (corps) corps.innerHTML = '<p class="t-body">' +
          (corps.dataset.erreur || 'Cart unavailable. Check your connection and try again.') + '</p>';
      })
      .then(function () {
        var corps = $('[data-bai-cart-body]');
        if (corps) corps.removeAttribute('aria-busy');
      });
  }

  if (btnCart) {
    btnCart.addEventListener('click', function (e) {
      // Sans JavaScript ce bouton est un vrai lien vers /cart : on ne
      // l'intercepte que si la feuille existe.
      var f = $('#dlg-cart');
      if (!f) return;
      e.preventDefault();
      ouvre(f, btnCart);
      litPanier();
    });
  }
  /* ── Ajout au panier sans quitter la page ────────────────────────────
     L'ajout rechargeait /cart : on quittait la fiche, ses options et son
     prix. On poste sur /cart/add.js et la feuille du panier s'ouvre sur la
     ligne ajoutee. Refus de Shopify (stock, quantite) : le message s'affiche
     sous le bouton. Panne reseau : on retombe sur l'envoi classique, la
     commande n'est jamais bloquee. */
  var coche = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    var feuille = $('#dlg-cart');
    if (!f || !feuille || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    var erreur = f.querySelector('.ajout-erreur');
    if (erreur) erreur.remove();
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fin = function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } };
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      }, function () { fin(); f.submit(); return null; })
      .then(function (res) {
        if (!res) return;
        fin();
        if (!res.ok) {
          var p = document.createElement('p');
          p.className = 'ajout-erreur t-sm'; p.setAttribute('role', 'alert');
          p.textContent = (res.d && (res.d.description || res.d.message)) ||
            'This item could not be added. Try again, or ask us on WhatsApp.';
          f.appendChild(p);
          return;
        }
        ouvre(feuille, btn);
        var nom = (res.d.product_title || '') +
          (res.d.variant_title && res.d.variant_title !== 'Default Title' ? ' · ' + res.d.variant_title : '');
        litPanier().then(function () {
          var corps = $('[data-bai-cart-body]');
          if (!corps) return;
          var ok = document.createElement('p');
          ok.className = 'panier-ajout t-sm'; ok.setAttribute('role', 'status');
          ok.innerHTML = coche + '<span></span>';
          ok.lastChild.textContent = 'Added: ' + nom.replace(/[<>&]/g, '');
          corps.insertBefore(ok, corps.firstChild);
        });
      })
      .catch(function () { fin(); f.submit(); });
  });

  /* ── Panneaux de navigation ─────────────────────────────────────────
     Ils s'ouvrent au survol sur grand ecran et au clic partout. Le filtre
     de mouvement corrige un defaut mesure : quand le DOM change sous un
     curseur immobile, le navigateur emet un pointerover fantome, qui
     refermait le panneau qu'on venait d'ouvrir au clic. */
  var volets = $$('.mega');
  var onglets = $$('.hdr-nav button[data-volet]');
  var lx = null, ly = null, minuteur = null;

  function fermeVolets() {
    volets.forEach(function (v) { v.dataset.ouvert = 'false'; v.hidden = true; });
    onglets.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
  }

  function ouvreVolet(id) {
    volets.forEach(function (v) {
      var oui = v.dataset.volet === id;
      v.hidden = !oui;
      v.dataset.ouvert = oui ? 'true' : 'false';
    });
    onglets.forEach(function (o) {
      o.setAttribute('aria-expanded', o.dataset.volet === id ? 'true' : 'false');
    });
  }

  onglets.forEach(function (o) {
    o.addEventListener('click', function () {
      var deja = o.getAttribute('aria-expanded') === 'true';
      clearTimeout(minuteur);
      if (deja) fermeVolets(); else ouvreVolet(o.dataset.volet);
    });
    o.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || window.innerWidth <= 900) return;
      if (lx !== null && Math.abs(e.clientX - lx) < 2 && Math.abs(e.clientY - ly) < 2) return;
      ouvreVolet(o.dataset.volet);
    });
  });
  document.addEventListener('pointermove', function (e) { lx = e.clientX; ly = e.clientY; }, { passive: true });
  document.addEventListener('pointerdown', function () { clearTimeout(minuteur); });

  var entete = $('.bai-hdr');
  if (entete) {
    entete.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse' || window.innerWidth <= 900) return;
      minuteur = setTimeout(fermeVolets, 180);
    });
    entete.addEventListener('pointerenter', function () { clearTimeout(minuteur); });
  }

  /* ── Tiroir (telephone) ─────────────────────────────────────────── */
  var burger = $('[data-bai-burger]');
  var rangee = $('.hdr-row');
  function fermeTiroir(rendFocus) {
    if (!burger || !rangee || rangee.dataset.menu !== 'true') return;
    rangee.dataset.menu = 'false';
    burger.setAttribute('aria-expanded', 'false');
    masqueBarre(false);
    if (rendFocus) burger.focus();
  }
  if (burger && rangee) {
    burger.addEventListener('click', function () {
      var ouvertNow = rangee.dataset.menu === 'true';
      rangee.dataset.menu = ouvertNow ? 'false' : 'true';
      burger.setAttribute('aria-expanded', ouvertNow ? 'false' : 'true');
      masqueBarre(!ouvertNow);
      if (ouvertNow) fermeVolets();
    });
  }

  /* ── Barre du bas sur une fiche produit ─────────────────────────────
     Deux boutons d'achat face a face, c'est un de trop : la barre se
     retire tant qu'un formulaire d'achat est a l'ecran. Sur une fiche a
     options, son bouton emmene d'abord aux options ; une fois le bloc
     d'achat vu, il ajoute la configuration choisie. */
  var formFiche = $('#fi-form');
  var btnBarre = $('[data-barre-add]');
  if (barre && formFiche && btnBarre) {
    var cibleAchat = $('[data-fi-opts]') || formFiche;
    var arme = function () {
      if (btnBarre.dataset.etat !== 'voir') return;
      btnBarre.dataset.etat = 'ajout';
      btnBarre.textContent = btnBarre.dataset.ajout;
      btnBarre.disabled = btnBarre.dataset.dispo === '0';
    };
    btnBarre.addEventListener('click', function (e) {
      if (btnBarre.dataset.etat !== 'voir') return;
      e.preventDefault();
      cibleAchat.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
    });
    var formes = $$('form[action*="/cart/add"]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          en.target.dataset.aLecran = en.isIntersecting ? '1' : '0';
          if (en.isIntersecting && en.target === formFiche) arme();
        });
        var un = formes.some(function (f) { return f.dataset.aLecran === '1'; });
        barre.dataset.vue = un ? 'true' : 'false';
      });
      formes.forEach(function (f) { io.observe(f); });
    } else {
      arme();
    }
  }

  /* ── Langue ─────────────────────────────────────────────────────── */
  var btnLang = $('[data-bai-lang]');
  if (btnLang) {
    var menuLang = $('.hdr-lang-menu');
    btnLang.addEventListener('click', function () {
      var o = btnLang.getAttribute('aria-expanded') === 'true';
      btnLang.setAttribute('aria-expanded', o ? 'false' : 'true');
      if (menuLang) menuLang.hidden = o;
    });
  }

  /* ── Onglets generiques ──────────────────────────────────────────────
     Un seul mecanisme pour « Pourquoi BAI » et les consommables. Les
     panneaux portent hidden, donc leur contenu existe sans JavaScript :
     une page sans script montre tout, elle ne montre pas rien. */
  $$('[role="tablist"]').forEach(function (strip) {
    var tabs = $$('[role="tab"]', strip);
    if (!tabs.length) return;
    function choisit(i) {
      tabs.forEach(function (t, j) {
        var actif = i === j;
        t.setAttribute('aria-selected', actif ? 'true' : 'false');
        t.tabIndex = actif ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !actif;
      });
      // Les photos de consommables suivent l'onglet, si la section en a.
      var shots = $$('.cons-shot');
      if (shots.length && strip.closest('.bai-cons')) {
        shots.forEach(function (s, j) { s.hidden = j !== i; });
      }
      glisse(strip, tabs[i]);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { choisit(i); });
    });
    strip.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1
            : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
      if (n < 0 && e.key !== 'Home') return;
      e.preventDefault();
      n = (n + tabs.length) % tabs.length;
      tabs[n].focus(); choisit(n);
    });
    var actif = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
    glisse(strip, actif || tabs[0]);
  });

  function glisse(strip, tab) {
    var g = $('.tab-glide', strip);
    if (!g || !tab) return;
    // La barre se replie sur deux rangees quand les libelles sont longs :
    // la pastille doit donc suivre en Y autant qu'en X, sinon elle reste
    // sur la premiere rangee pendant qu'on selectionne la seconde.
    g.style.width = tab.offsetWidth + 'px';
    g.style.height = tab.offsetHeight + 'px';
    g.style.setProperty('--gx', tab.offsetLeft + 'px');
    g.style.setProperty('--gy', tab.offsetTop + 'px');
    if (reduit) g.style.transition = 'none';
  }

  /* ── Chapitres replies sur telephone ─────────────────────────
     Le repli suit la LARGEUR, dans les deux sens. La version precedente
     le posait une fois pour toutes : retrecir la fenetre refermait les
     six chapitres, et l'elargir ne les rouvrait pas. On revenait sur un
     bureau de 1 440 px couvert de titres vides, sans rien qui dise ce
     qui les avait fermes ni comment les rouvrir tous.

     Le geste du visiteur reste prioritaire : un chapitre qu'il a ouvert
     ou ferme lui-meme ne bouge plus tant qu'on ne franchit pas la borne.
     La franchir remet les compteurs a zero, parce qu'a ce moment-la ce
     n'est plus la meme page qu'il regarde. */
  var etroit = window.matchMedia('(max-width:900px)');
  var chapitres = $$('[data-replie-mobile]');
  var manuel = [];
  var bascule = false;

  chapitres.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!bascule && manuel.indexOf(d) < 0) manuel.push(d);
    });
  });

  function accordeChapitres() {
    bascule = true;
    chapitres.forEach(function (d) {
      if (manuel.indexOf(d) < 0) d.open = !etroit.matches;
    });
    // toggle part en differe : le drapeau doit lui survivre
    setTimeout(function () { bascule = false; }, 0);
  }
  accordeChapitres();

  function franchi() { manuel = []; accordeChapitres(); }
  if (etroit.addEventListener) etroit.addEventListener('change', franchi);
  else if (etroit.addListener) etroit.addListener(franchi);

  /* Une ancre qui vise un chapitre replie l'OUVRE : sinon le lien du menu
     mene a un titre ferme, c'est-a-dire a rien. */
  function ouvreCible(hash) {
    if (!hash || hash.length < 2) return;
    var el = null;
    try { el = document.querySelector(hash); } catch (e) { return; }
    if (!el) return;
    for (var p = el; p; p = p.parentElement) {
      if (p.tagName === 'DETAILS' && !p.open) p.open = true;
    }
    var d = el.querySelector && el.querySelector('details.chapitre');
    if (d) d.open = true;
  }
  /* Les liens du menu et du pied de page visent « /#machines » et non
     « #machines » : une ancre nue ne vaut que sur la page qui la contient,
     donc depuis une fiche produit elle ne menait nulle part. Reste le cas
     de la page d'accueil, ou « /#machines » rechargerait la page pour
     descendre de trois ecrans. On l'intercepte : meme lien, deux
     comportements justes. */
  var surAccueil = document.body.dataset.tpl === 'index';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href) return;
    var hash = null;
    if (href.charAt(0) === '#') hash = href;
    // « /#machines » defile sur place des que la cible existe sur la page
    // (accueil, collection des machines) au lieu de recharger l'accueil.
    else if (href.indexOf('/#') === 0 && (surAccueil || document.getElementById(href.slice(2)))) hash = href.slice(1);
    if (!hash) return;
    fermeTiroir(false);
    fermeVolets();
    ouvreCible(hash);
    var cible = null;
    try { cible = document.querySelector(hash); } catch (err) { return; }
    if (!cible) return;
    e.preventDefault();
    cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
    // L'adresse doit suivre : sans ca, actualiser la page fait remonter
    // en haut alors qu'on etait au milieu.
    if (history.replaceState) history.replaceState(null, '', hash);
  });
  window.addEventListener('hashchange', function () { ouvreCible(location.hash); });
  if (location.hash) ouvreCible(location.hash);

  /* ── Rails de defilement ─────────────────────────────────────────────
     Sur telephone, rien ne disait qu'un bloc defile lateralement. Le rail
     dit trois choses d'un coup : qu'il y a une suite, combien, et ou on en
     est. On le pose AVANT le defileur quand celui-ci depasse 55 % de la
     hauteur de l'ecran, sinon l'indice arrive apres qu'on a renonce. */
  $$('.m-grid, .avis-mur, .atelier, .cons-shots').forEach(function (sc) {
    if (sc.scrollWidth <= sc.clientWidth + 4) return;
    if (sc.parentNode.querySelector(':scope > .rail')) return;
    var rail = document.createElement('div');
    rail.className = 'rail';
    rail.setAttribute('aria-hidden', 'true');
    rail.innerHTML = '<span class="rail-pouce"></span>';
    var haut = sc.getBoundingClientRect().height > window.innerHeight * 0.55;
    sc.parentNode.insertBefore(rail, haut ? sc : sc.nextSibling);
    var pouce = rail.firstChild;
    function maj() {
      var part = sc.clientWidth / sc.scrollWidth;
      var max = sc.scrollWidth - sc.clientWidth;
      pouce.style.width = Math.max(part * 100, 12) + '%';
      pouce.style.transform = 'translateX(' + (max ? (sc.scrollLeft / max) * (100 / part - 100) : 0) + '%)';
    }
    sc.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  });

  /* ── Selecteur de brodeuse ─────────────────────────────────
     Les trois boutons menent a la carte correspondante. Ils visaient un
     defilement LATERAL de la grille ; la grille s'empile desormais, donc
     scrollTo({left}) ne deplacait plus rien et le bouton ne faisait plus
     rien du tout. On vise la carte, pas l'axe. */
  var grille = $('.m-grid');
  var choix = $$('.m-choix-b');
  if (grille && choix.length) {
    choix.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var c = grille.children[i];
        if (!c) return;
        choix.forEach(function (o, j) { o.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        marque(i);
        if (grille.scrollWidth > grille.clientWidth + 4) {
          grille.scrollTo({ left: c.offsetLeft - grille.offsetLeft, behavior: reduit ? 'auto' : 'smooth' });
        } else {
          c.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
    var tic = null;
    grille.addEventListener('scroll', function () {
      if (tic) return;
      tic = requestAnimationFrame(function () {
        tic = null;
        var centre = grille.scrollLeft + grille.clientWidth / 2, best = 0, d = Infinity;
        Array.prototype.forEach.call(grille.children, function (c, i) {
          var dc = Math.abs(c.offsetLeft - grille.offsetLeft + c.offsetWidth / 2 - centre);
          if (dc < d) { d = dc; best = i; }
        });
        choix.forEach(function (b, i) { b.setAttribute('aria-selected', i === best ? 'true' : 'false'); });
        marque(best);
      });
    }, { passive: true });

    /* La carte calee porte `data-actif`. C'est l'equivalent tactile du
       survol : le doigt ne survole pas, il amene une carte sous les yeux.
       Le CSS s'en sert pour tracer le filet et agrandir la brodeuse.
       Meme calcul que l'onglet, donc aucun ecouteur supplementaire. */
    function marque(i) {
      Array.prototype.forEach.call(grille.children, function (c, j) {
        if (j === i) c.setAttribute('data-actif', '');
        else c.removeAttribute('data-actif');
      });
    }
    marque(0);

    /* ── Glisser le carrousel au pointeur ────────────────────────
       Sur telephone le doigt fait defiler tout seul : le navigateur
       s'en charge, avec son inertie et son calage. On ne touche a
       rien la (pointerType 'touch' sort tout de suite) -- intercepter
       le tactile casserait l'elan et le snap natifs.

       A la souris, rien ne se passait : la barre de defilement est
       masquee et un glisser ne fait pas defiler un bloc. Le client
       voyait donc le carrousel sans pouvoir l'ouvrir. On lui rend le
       geste qu'il attend, et le curseur le dit.

       Deux pieges, tous deux traites :
       - l'image et le panneau sont dans un <a> : le navigateur lance
         son propre glisser de lien. `draggable=false` l'en empeche.
       - au relachement, ce meme <a> declenche sa navigation. On
         avale le clic quand le doigt a parcouru plus de 6 px. */
    var glisse = null;
    grille.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (grille.scrollWidth <= grille.clientWidth + 4) return;
      glisse = { x: e.clientX, depart: grille.scrollLeft, bouge: false };
      grille.setPointerCapture(e.pointerId);
      grille.style.cursor = 'grabbing';
      grille.style.scrollSnapType = 'none';
    });
    grille.addEventListener('pointermove', function (e) {
      if (!glisse) return;
      var d = e.clientX - glisse.x;
      if (!glisse.bouge && Math.abs(d) > 6) glisse.bouge = true;
      if (glisse.bouge) grille.scrollLeft = glisse.depart - d;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      grille.addEventListener(ev, function (e) {
        if (!glisse) return;
        var abouge = glisse.bouge;
        glisse = null;
        grille.style.cursor = '';
        /* On rend le calage APRES le relachement : il ramene alors la
           carte la plus proche sous le doigt, comme un carrousel. */
        grille.style.scrollSnapType = '';
        if (abouge) {
          var avale = function (c) { c.preventDefault(); c.stopPropagation(); };
          grille.addEventListener('click', avale, { capture: true, once: true });
          setTimeout(function () {
            grille.removeEventListener('click', avale, { capture: true });
          }, 0);
        }
      });
    });
  }

  /* ── La collection ne s'arrete plus a cinquante ──────────────────────
     Liquid ne pagine pas au-dela de cinquante articles : c'est une limite
     de Shopify, pas un reglage. Les pieces MIRROR sont 55, les pieces
     toutes machines 82 — le reste vivait derriere un « Suivant » que
     personne ne cliquait.

     On va chercher la page suivante, on en extrait les cartes et on les
     ajoute a la liste en place. Le visiteur ne change jamais de page : il
     voit une liste qui s'allonge, ce qui est la verite du catalogue.

     Le bouton disparait quand il n'y a plus rien a charger, et la
     pagination reste dans le document pour ceux qui n'ont pas de
     JavaScript et pour les moteurs. */
  var suite = $('.col-suite');
  if (suite) {
    var bouton = $('.col-plus', suite);
    var liste = $('.col-produits');
    var vif = $('.col-compte-vif', suite);
    var pages = $('.col-pages', suite);
    if (bouton && liste) {
      // La pagination visible ne sert plus que de repli : on la retire de
      // l'ecran, pas du document.
      if (pages) pages.hidden = true;
      var occupe = false;
      bouton.addEventListener('click', function () {
        var url = bouton.dataset.suivante;
        if (!url || occupe) return;
        occupe = true;
        var dit = bouton.textContent.trim();
        bouton.setAttribute('aria-busy', 'true');
        fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var neuves = doc.querySelectorAll('.col-produits > .col-carte');
            Array.prototype.forEach.call(neuves, function (c) {
              liste.appendChild(document.importNode(c, true));
            });
            var apres = doc.querySelector('.col-plus');
            if (apres && apres.dataset.suivante) {
              bouton.dataset.suivante = apres.dataset.suivante;
              var n = apres.querySelector('.col-plus-n');
              var m = bouton.querySelector('.col-plus-n');
              if (n && m) m.textContent = n.textContent;
            } else {
              bouton.remove();
              if (vif) vif.textContent = suite.dataset.fin || '';
            }
            if (vif) {
              var total = liste.querySelectorAll('.col-carte').length;
              vif.textContent = total + ' / ' + (suite.dataset.total || total);
            }
          })
          .catch(function () {
            // En cas d'echec on rend la pagination : un cul-de-sac serait pire.
            if (pages) pages.hidden = false;
            bouton.remove();
          })
          .then(function () {
            occupe = false;
            bouton.removeAttribute && bouton.removeAttribute('aria-busy');
          });
      });
    }
  }

  /* ── Compteur de quantite ────────────────────────────────────────────
     Les deux boutons de la maquette sont du HTML inerte : elle n'avait pas
     de panier a servir. Ici ils pilotent le champ « quantity » du
     formulaire d'ajout, donc ce que le visiteur voit est ce qui part.

     On declenche « change » a la main : le champ est modifie par script,
     et sans cet evenement rien de ce qui ecoute le formulaire ne le sait. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qte]');
    if (!b) return;
    var boite = b.closest('.fi-qte');
    var champ = boite && boite.querySelector('input[name="quantity"]');
    if (!champ) return;
    var pas = parseInt(b.dataset.qte, 10) || 0;
    var mini = parseInt(champ.min, 10);
    if (isNaN(mini)) mini = 1;
    var val = parseInt(champ.value, 10);
    if (isNaN(val)) val = mini;
    champ.value = Math.max(mini, val + pas);
    champ.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Videos YouTube a la demande ──────────────────────────────────────
     Rien n'est demande a YouTube avant le clic : la page reste legere et
     aucun cookie tiers n'est pose sans geste du visiteur. Le lecteur
     youtube-nocookie remplace la vignette, a la meme place. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-yt]');
    if (!a) return;
    var cadre = a.closest('.yt');
    if (!cadre) return;
    e.preventDefault();
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(a.dataset.yt) + '?autoplay=1&rel=0&playsinline=1';
    f.title = a.dataset.ytTitre || 'YouTube video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.setAttribute('allowfullscreen', '');
    cadre.innerHTML = '';
    cadre.appendChild(f);
    f.focus();
  });

  /* ── Retour en haut ─────────────────────────────────────────────── */
  var haut = $('[data-bai-top]');
  if (haut) {
    var seuil = function () { haut.hidden = window.scrollY < window.innerHeight * 1.5; };
    window.addEventListener('scroll', seuil, { passive: true });
    seuil();
    haut.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduit ? 'auto' : 'smooth' });
      var cible = $('#main-content');
      if (cible) cible.focus({ preventScroll: true });
    });
  }

  /* ── Cookies ─────────────────────────────────────────────────────────
     Le choix vit dans localStorage, pas dans un cookie : on ne depose rien
     avant d'avoir demande. Refuser doit etre aussi simple qu'accepter,
     donc les deux boutons sont cote a cote et de meme taille. */
  var banniere = $('[data-bai-cookies]');
  if (banniere) {
    var CLE = 'bai-cookies';
    var deja = null;
    try { deja = localStorage.getItem(CLE); } catch (e) { deja = null; }
    if (deja) banniere.remove();
    else {
      $$('[data-bai-cookie]').forEach(function (b) {
        b.addEventListener('click', function () {
          try { localStorage.setItem(CLE, b.dataset.baiCookie); } catch (e) {}
          banniere.remove();
          document.documentElement.style.removeProperty('--cookie-h');
        });
      });
      var h = banniere.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--cookie-h', Math.round(h) + 'px');
    }
  }

  /* ── Editeur de theme ────────────────────────────────────────────────
     Shopify rerend une section seule : sans ces ecouteurs, une section
     rechargee perd ses onglets, ses rails et ses chapitres, et le client
     croit que le theme est casse alors que c'est l'editeur. */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { location.reload(); });
  }
})();
